<ng-container *ngFor="let data_ of data">

    <div class="adc-chk" *ngIf="data_.type == 'default'">
      <ng-container *ngFor="let items of data_.items">
        <input type="checkbox" (change)="onCheckboxChange(items.itemId)" name="{{items.itemName}}" id="{{items.itemId}}" [checked]="items.checked" [disabled]="items.disabled">
        <label for="{{items.itemId}}">
            {{items.itemLabel}}
        </label>
      </ng-container>
    </div>
  
    <form class="adc-chkgrp-hr" *ngIf="data_.type == 'horizontal'">
      <div class="adc-chk" *ngFor="let i of data_.items">
        <input type="checkbox" (change)="onCheckboxChange(i.itemId)" name="{{i.itemName}}" id="{{i.itemId}}" [checked]="i.checked" [disabled]="i.disabled">
        <label for="{{i.itemId}}">
          {{i.itemLabel}}
        </label>
      </div>
    </form>
  
    <form class="adc-chkgrp-vr" *ngIf="data_.type == 'vertical'">
      <div class="adc-chk" *ngFor="let i of data_.items">
        <input type="checkbox" (change)="onCheckboxChange(i.itemId)" name="{{i.itemName}}" id="{{i.itemId}}" [checked]="i.checked" [disabled]="i.disabled">
        <label for="{{i.itemId}}">
          {{i.itemLabel}}
        </label>
      </div>
    </form>
  
  </ng-container>
  